import { render, staticRenderFns } from "./FactoryLoad.vue?vue&type=template&id=28f71962"
import script from "./FactoryLoad.vue?vue&type=script&lang=js"
export * from "./FactoryLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports